export { FeaturedTag } from './FeaturedTag';
